import { CommonModule } from '@angular/common';
import {
AfterViewInit,
ChangeDetectionStrategy,
Component,
EventEmitter,
Input,OnDestroy,
Output,
ViewChild
} from "@angular/core";
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { BehaviorSubject, combineLatest, Observable, Subscription, switchMap } from "rxjs";
import { filter, map } from 'rxjs/operators';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { LoadingService } from "../../../../services/loading.service";
import { ArlAmountCalculationViewComponent } from '../arl-amount-calculation-view/arl-amount-calculation-view.component';
import { ArlCalculationViewComponent } from '../arl-calculation-view/arl-calculation-view.component';
import { LedgerImportARLCalculationPreChargeByType } from '../../../../dave-data-module/entities/ledger-import.entity';
import { arlQuantityHistoryFormGroup } from '../arl-form-data.service';
import { ARLTableCalculationPosition } from '../arl-table/arl-table-position-helper';

@Component({
    selector: 'app-arl-table-detail-row',
    standalone: true,
    imports: [CommonModule, ArlAmountCalculationViewComponent, ArlCalculationViewComponent, AppButtonModule, MatButtonModule, MatSlideToggleModule, ReactiveFormsModule],
    templateUrl: './arl-table-detail-row.component.html',
    styleUrls: ['./arl-table-detail-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlTableDetailRowComponent implements AfterViewInit, OnDestroy {
    // @ViewChild(ArlCalculationViewComponent) arlCalculationViewComponent: ArlCalculationViewComponent;
    @Output() AbortClick = new EventEmitter<void>();
    protected _inheritFromChildrenForm: FormControl<boolean> = null;
    private inheritFromChildrenFormSubscription: Subscription = null;
    private childrenVisibleFormSubscription: Subscription = null;
    // @Input() set inheritFromChildrenForm(form: FormControl<boolean>) {
    //     this._inheritFromChildrenForm = form;
    //     if (form && form.value && !this.clacViewExpanded) {
    //         this.clacViewExpanded = true;
    //     }
    //     this.inheritFromChildrenFormSubscription?.unsubscribe();
    //     this.inheritFromChildrenFormSubscription = form?.valueChanges.subscribe((val) => {
    //         if (val && !this.clacViewExpanded) {
    //             this.clacViewExpanded = true;
    //         }
    //     });
    // }
    @Input() quantityHistoryForm: FormGroup<{
        ShowQuantityHistory: FormControl<boolean>;
        UseQuantityHistory: FormControl<boolean>;
        QuantityHistory: FormArray<arlQuantityHistoryFormGroup>;
        Quantity: FormControl<number>;
    }>;
    // @Input() childrenVisibleForm: FormControl<boolean> = null;

    // @Input() ARLCalculationPreChargeByTypes: LedgerImportARLCalculationPreChargeByType[];
    // @Input() aRLCalculationPreCharge: number;
    // @Input() ZuschlaegeResourcen: number;
    // @Input() ZuschlaegeMaterials: number;
    // @Input() ZuschlaegeDefault: number;
    // @Input() ZuschlaegeEmployee: number;
    // @Input() ZuschlaegeExternalService: number;
    // @Input() ZuschlaegeOther: number;
    protected _arlTableCalculationPositionHelper: ARLTableCalculationPosition;
    @Input() set arlTableCalculationPositionHelper(v: ARLTableCalculationPosition) {
        this._arlTableCalculationPositionHelper = v;
        if (v) {
            this._inheritFromChildrenForm = v.parentForm.controls.InheritFromChildren;
            if (this._inheritFromChildrenForm && this._inheritFromChildrenForm.value && !this.clacViewExpanded) {
                this.clacViewExpanded = true;
            }
            this.inheritFromChildrenFormSubscription?.unsubscribe();
            this.inheritFromChildrenFormSubscription = this._inheritFromChildrenForm?.valueChanges.subscribe((val) => {
                if (val && !this.clacViewExpanded) {
                    this.clacViewExpanded = true;
                }
            });

            this.childrenVisibleFormSubscription?.unsubscribe();
            this.childrenVisibleFormSubscription = v.childArls$.pipe(
                map((arls) => /*arls.length === 0 ||*/ arls.some((a) => a.IsVisible))).subscribe((showChilds) => {
                // console.log({ someVisible: showChilds, dirty: this.childrenVisibleForm.dirty, value: this.childrenVisibleForm.value });
                if (!v.parentForm.controls.childrenVisible.dirty && v.parentForm.controls.childrenVisible.value !== showChilds) {
                    v.parentForm.controls.childrenVisible.setValue(showChilds);
                    // console.log({ value: this.childrenVisibleForm.value });
                    v.parentForm.controls.childrenVisible.markAsPristine();
                }
            })
        }
    }

    @Input() FilterMaterialsByCustomerId: number | null = null;
    @Input() forceQuantityTypeIdForEmployeeArls: number | null = null;
    // @Input() UseAmountFromMaterialToSupplier: boolean = false;
    @Input() isOrder = false
    @Input() isOffer = false;
    // @Output() calculatedAmount = new EventEmitter<{BaseCost: number, SalaryBaseCost: number}>();
    // @Input() set position(val: string) {
    //     this._positionPrefix = (val && val + '') || '';
    // }
    @Input() disabled = false;
    // protected _positionPrefix: string;
    protected clacViewExpanded = false;
    protected clacAmountViewExpanded = false;
    // arlForm = new FormGroup({
    //     // Amount: new FormControl<number>(null),
    //     // Information: new FormControl<string>(null),
    //     // BookingText: new FormControl<string>(null),
    //     // BaseCost: new FormControl<number>(null),
    //     // Quantity: new FormControl<number>(null),
    //     // QuantityTypeId: new FormControl<number>(null),
    //     ChildIds: new FormControl<Array<number>>(null)
    // });
    // protected _arl: AccountsReceivableLedgerEntity = null;
    // @Input() set arl(v: AccountsReceivableLedgerEntity /*| AccountsReceivableLedgerTemplateEntity*/) {
    //     // todo checken ob template oder nicht
    //     // AccountsReceivableLedgerTemplateEntity hat keinen amount
    //     this._arl = v;
    //     if (v) {
    //         // this.arlForm.setValue({
    //         //     // Amount: v.Amount,
    //         //     // Information: v.Information,
    //         //     // BookingText: v.BookingText,
    //         //     // BaseCost: v.BaseCost,
    //         //     // Quantity: v.Quantity,
    //         //     // QuantityTypeId: v.QuantityTypeId,
    //         //     ChildIds: v.ArlIds || [],
    //         // });
    //         // this.arlForm.markAsPristine();
    //     }
    // }
    // get arl() {
    //     return this._arl;
    // }
    // public someFormDirty$: Observable<boolean>;
    // private _ArlFormDirty$ = new BehaviorSubject<boolean>(false);
    // @Input() set ArlFormDirty(v: boolean) {
        // console.log('invoice-editor-dirty-debug: ArlFormDirty', v, this.arl)
    //     this._ArlFormDirty$.next(v);
    // }
    // protected someFormInvalid$: Observable<boolean>;
    // private _ArlFormInvalid$ = new BehaviorSubject<boolean>(false);
    // @Input() set ArlFormInvalid(v: boolean) {
    //     this._ArlFormInvalid$.next(v);
    // }
    constructor(protected ls: LoadingService) {
        // this.arlHelper$.pipe(
        //     filter(v => !!v),
        //     switchMap(h => h.childArls$),
        //     map((arls) => /*arls.length === 0 ||*/ arls.some((a) => a.IsVisible))).subscribe((showChilds) => {
        //     // console.log({ someVisible: showChilds, dirty: this.childrenVisibleForm.dirty, value: this.childrenVisibleForm.value });
        //     if (!this.childrenVisibleForm.dirty && this.childrenVisibleForm.value !== showChilds) {
        //         this.childrenVisibleForm.setValue(showChilds);
        //         // console.log({ value: this.childrenVisibleForm.value });
        //         this.childrenVisibleForm.markAsPristine();
        //     }
        // }),
    }

    ngAfterViewInit(): void {
        // this.someFormDirty$ = combineLatest([this.arlTableCalculationPositionHelper.arlFormsDirty$, this._ArlFormDirty$]).pipe(map((dirties) => dirties.includes(true)));
        // this.someFormInvalid$ = combineLatest([this.arlTableCalculationPositionHelper.arlFormsInvalid$, this._ArlFormInvalid$]).pipe(map((invalids) => invalids.includes(true)));
        // this.someFormDirty$ = combineLatest([this.arlCalculationViewComponent.arlFormsDirty$, this._ArlFormDirty$]).pipe(map((dirties) => dirties.includes(true)));
        // this.someFormInvalid$ = combineLatest([this.arlCalculationViewComponent.arlFormsInvalid$, this._ArlFormInvalid$]).pipe(map((invalids) => invalids.includes(true)));
    }
    // Submit() {
    //     alert('todo must be handled in arltablecomponent')
    //     // return this.arlCalculationViewComponent?.submit(); todo
    // }
    protected onAbortClick() {
        this.AbortClick.emit();
    }


    ngOnDestroy(): void {
        this.inheritFromChildrenFormSubscription?.unsubscribe();
        this.childrenVisibleFormSubscription?.unsubscribe();
    }
}
